import { CloseOutlined } from '@ant-design/icons'
import { Button, Divider, Drawer, Form, Modal } from 'antd'
import Avatar from 'components/Avatar'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import BlueShareIcon from 'components/icons/BlueShareIcon'
import CopyIcon from 'components/icons/CopyIcon'
import EmailAtIcon from 'components/icons/EmailAtIcon'
import Emptystates from 'components/icons/Emptystates.svg'
import FaceBookBlueIcon from 'components/icons/FaceBookBlueIcon'
import LinkedIcon from 'components/icons/LinkedIcon'
import TwitterIcon from 'components/icons/TwitterIcon'
import WhatsappIcon from 'components/icons/WhatsappIcon'
import Label from 'components/Label/Label'
import DetailsHeader from 'modules/Roles/Partials/ViewIndividualRole/Components/DetailsHeader/index.js'
import {
  CenteredDiv,
  ColListIcon,
  Content,
  DisplayPad,
  LinkText,
  MailSubHeading,
  RowListIcon,
  RowListLabel,
  RowPadding,
  ShareLink,
  ShareSection,
  ShareWrap,
} from 'modules/Roles/Partials/ViewIndividualRole/Components/ShareDrawer/style'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import styled from 'styled-components'
import { IsValidEmail } from 'utils/emailValidation'
import SuccessMessage from 'utils/SuccessMessage'
const { REACT_APP_JOB_SHARING_URL } = process.env

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 30px;
  }
`
const closeIconStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  padding: '20px',
}

function ShareDrawer({
  singleRoleDetails,
  jobSharingEmail,
  subEvents,
  subEventId,
}) {
  const [visible, setVisible] = useState(false)
  const [isCopied, setIsCopied] = useState(false)
  const dispatch = useDispatch()
  const [enteredEmail, setEnteredEmail] = useState('')

  const RoleId = singleRoleDetails?.id
  const CorpId = singleRoleDetails?.corporateId
  const shareUrl = `${REACT_APP_JOB_SHARING_URL}${CorpId}/${RoleId}`

  const [form] = Form.useForm()

  const onShareClick = copyText => {
    navigator.clipboard.writeText(copyText)
    SuccessMessage('Copied')
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 10000)
  }
  const onEmailEntered = e => {
    setEnteredEmail(e.target.value)
  }
  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return 'Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }
  const formatNumber = (number = 0) => {
    return number.toLocaleString('en-US')
  }
  const sendEmailOTP = async values => {
    let mandatory = singleRoleDetails?.mandatorySkillName
      ?.map(item => item?.name)
      ?.join(',')
    let optional = singleRoleDetails?.optionalSkillsName
      ?.map(item => item?.name)
      ?.join(',')
    let remote = singleRoleDetails?.remoteCities
      ?.map(item => item.name)
      ?.join(',')
    let city = singleRoleDetails?.cities?.map(item => item.name)?.join(',')
    let yearOfPassing = singleRoleDetails?.yearOfPassing?.join(',')
    let experiences = checkJobTypeLevel(
      singleRoleDetails?.jobTypeLevels,
      singleRoleDetails?.yearOfExperience
    )
    let degree = singleRoleDetails?.degreeStreamMap?.map(
      item => item?.degree?.name + '-' + item?.stream?.name
    )

    let ctc =
      singleRoleDetails?.minCompensation == singleRoleDetails?.maxCompensation
        ? '₹' + formatNumber(Number(singleRoleDetails?.minCompensation))
        : '₹' +
          formatNumber(Number(singleRoleDetails?.minCompensation)) +
          ' - ' +
          '₹' +
          formatNumber(Number(singleRoleDetails?.maxCompensation))

    let ctcperiod =
      singleRoleDetails?.CTCPeriod == 'ANNUALLY'
        ? ' Per annum'
        : singleRoleDetails?.CTCPeriod == 'MONTHLY'
        ? ' Per month'
        : singleRoleDetails?.CTCPeriod == 'WEEKLY'
        ? ' Per week'
        : singleRoleDetails?.CTCPeriod == 'DAILY'
        ? ' Per day'
        : singleRoleDetails?.CTCPeriod == 'HOURLY'
        ? ' Per hour'
        : ''
    let combinedCtc = ctc + ctcperiod

    dispatch(
      jobSharingEmail(
        {
          payload: {
            id: singleRoleDetails?.id,
            email: enteredEmail,
            link: shareUrl,
            jobDependency: singleRoleDetails?.jobDependency,
            corporateName: singleRoleDetails?.corporate?.name,
            industry: singleRoleDetails?.corporate?.industry,
            cities: city,
            mandatorySkills: mandatory,
            optionalSkills: optional,
            isRemoteAllowed: singleRoleDetails?.isRemoteAllowed,
            remoteCities: remote,
            eligibility: degree,
            yearOfPassing: yearOfPassing,
            experience: experiences,
            tittle: singleRoleDetails?.tittle,
            jobType: singleRoleDetails?.jobType
              ?.split('_')
              ?.join(' ')
              .toLowerCase(),
            description: singleRoleDetails?.description,
            ctcPeriod: combinedCtc,
          },
        },
        subEventId
      )
    )
    setIsModalVisible(!isModalVisible)
  }

  const [isModalVisible, setIsModalVisible] = useState(false)
  const handleModalToggle = () => {
    setIsModalVisible(!isModalVisible)
  }

  return (
    <>
      <Button
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingRight: '10px',
        }}
        icon={<BlueShareIcon />}
        onClick={() => setVisible(true)}
      />

      <StyledDrawer
        title="Share Job Details"
        placement="right"
        closable={true}
        closeIcon={<CloseOutlined style={closeIconStyle} />}
        onClose={() => setVisible(false)}
        visible={visible}
        width="40%"
      >
        <ShareWrap column>
          <DetailsHeader
            tittle={singleRoleDetails?.tittle}
            jobyType={singleRoleDetails?.jobType}
            candidatesCount={`${typeof singleRoleDetails?.minVacancies === 'object' ? singleRoleDetails?.minVacancies?.value || singleRoleDetails?.minVacancies : singleRoleDetails?.minVacancies} - ${typeof singleRoleDetails?.maxVacancies === 'object' ? singleRoleDetails?.maxVacancies?.value || singleRoleDetails?.maxVacancies : singleRoleDetails?.maxVacancies}`}
            date={singleRoleDetails?.endDate}
          />
          <Divider />
          <RowListIcon row>
            <ColListIcon column alignCenter>
              <LinkedinShareButton url={shareUrl}>
                <Avatar
                  size={72}
                  src={<LinkedIcon />}
                  background={'#9D9D9D0A'}
                  padding={'25px'}
                />
              </LinkedinShareButton>

              <RowListLabel>Linked In</RowListLabel>
            </ColListIcon>
            <ColListIcon column alignCenter>
              <FacebookShareButton url={shareUrl}>
                <Avatar
                  size={72}
                  src={<FaceBookBlueIcon />}
                  background={'#9D9D9D0A'}
                  padding={'25px'}
                />
              </FacebookShareButton>
              <RowListLabel>Facebook</RowListLabel>
            </ColListIcon>
            <ColListIcon column alignCenter>
              <TwitterShareButton url={shareUrl}>
                <Avatar
                  size={72}
                  src={<TwitterIcon />}
                  background={'#9D9D9D0A'}
                  padding={'25px'}
                />
              </TwitterShareButton>

              <RowListLabel>Twitter</RowListLabel>
            </ColListIcon>
            <ColListIcon column alignCenter>
              <EmailShareButton onClick={handleModalToggle} url={shareUrl}>
                <Avatar
                  size={72}
                  src={<EmailAtIcon />}
                  background={'#9D9D9D0A'}
                  padding={'25px'}
                />
              </EmailShareButton>

              <RowListLabel>E-Mail</RowListLabel>
            </ColListIcon>
            <ColListIcon column alignCenter>
              <WhatsappShareButton url={shareUrl}>
                <Avatar
                  size={72}
                  src={<WhatsappIcon />}
                  background={'#9D9D9D0A'}
                  padding={'25px'}
                />
              </WhatsappShareButton>
              <RowListLabel>Whatsapp</RowListLabel>
            </ColListIcon>
          </RowListIcon>
          <CenteredDiv>Or share with link</CenteredDiv>
          <LinkText>{isCopied ? 'Link Copied' : 'Click to copy link'}</LinkText>
          <ShareSection spaceBetween onClick={() => onShareClick(shareUrl)}>
            <ShareLink id="copy">{shareUrl}</ShareLink>
            <CopyIcon color={isCopied ? '#3249D7' : '#D1D2D3'} />
          </ShareSection>
        </ShareWrap>
      </StyledDrawer>
      <div>
        <Modal
          width={'585px'}
          visible={isModalVisible}
          onCancel={handleModalToggle}
          footer={null}
        >
          <RowPadding>
            <Content alignCenter column center>
              <Flex>
                <img src={Emptystates} alt="" />
              </Flex>

              <MailSubHeading>Share Job with your friends</MailSubHeading>
            </Content>
            <Form
              style={{ width: '100%' }}
              scrollToFirstError
              onFinish={sendEmailOTP}
              id={'emailForm'}
              form={form}
              layout="vertical"
            >
              <Label>Your friend's email address *</Label>
              <AntdInput
                AntdInput
                placeholder="eg:harry@yahoo.com"
                width="100%"
                name="Email"
                onChange={onEmailEntered}
                rules={[
                  () => ({
                    validator(_, value) {
                      let isValid = IsValidEmail(value)
                      if (!isValid) {
                        return Promise.reject(
                          new Error(`Please Enter Valid Email`)
                        )
                      }

                      return Promise.resolve()
                    },
                  }),
                ]}
              />
              <DisplayPad>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    width: '100%',
                    height: '45px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                  }}
                  padding="10px"
                >
                  Submit
                </Button>
              </DisplayPad>
            </Form>
          </RowPadding>
        </Modal>
      </div>
    </>
  )
}
export default ShareDrawer
